import React, { useContext } from 'react';

import AppContext from '../AppContext';

function HelpView() {
  const { t, i18n } = useContext(AppContext);

  return (
    <div>
      <iframe src={`help_${i18n.language}.html`} title={t("command.help")} style={{ width: '100%', height: '100vh' }} />
    </div>
  );
}

export default HelpView;
